import { render } from "./red-circle.vue?vue&type=template&id=5e550409"
import script from "./red-circle.vue?vue&type=script&lang=js"
export * from "./red-circle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__